import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'

export function IdentityReviewActions({ reason, disabled, onDecision, initialTarget = '' }: {
 reason: string
 disabled?: boolean
 initialTarget?: string
 onDecision: (decision: 'independent' | 'merge', targetId?: string) => Promise<void>
}) {
 const { t } = useTranslation()
 const [target, setTarget] = useState(initialTarget)
 return <div className="flex flex-wrap items-center gap-2">
   {reason === 'entity_type_conflict' ? <Button size="sm" variant="outline" disabled={disabled} onClick={() => void onDecision('independent')}>{t('ingestReview.identity.independent')}</Button> : null}
   <Input aria-label={t('ingestReview.identity.target')} placeholder={t('ingestReview.identity.target')} value={target} onChange={(event) => setTarget(event.target.value)} />
   <Button size="sm" variant="outline" disabled={disabled || !target.trim()} onClick={() => void onDecision('merge', target.trim())}>{t('ingestReview.identity.merge')}</Button>
 </div>
}
